import { Injectable } from '@angular/core';
import { EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { TagInterface } from '@shared/api';
import { Subject } from 'rxjs';
import { CustomEntityCollectionBaseService } from '../entity-collection-base.class';
import { EntityTypeEnum } from '../entity.interface';

export interface ToggleTagInterface {
  items: string[];
  addTags: TagInterface[];
  removeTags: TagInterface[];
}

export interface RenameTagInterface {
  tagId: string;
  newName: string;
}

export interface DeleteTagInterface {
  tagId: string;
}

@Injectable({
  providedIn: 'root',
})
export class TagsService extends CustomEntityCollectionBaseService<TagInterface> {
  entitiesSetup = new Subject<{
    entitiesIds: string[];
    type: EntityTypeEnum;
  }>();

  toggleTags$ = new Subject<ToggleTagInterface>();
  renameTag$ = new Subject<RenameTagInterface>();
  deleteTag$ = new Subject<DeleteTagInterface>();

  constructor(elementsFactory: EntityCollectionServiceElementsFactory) {
    super(EntityTypeEnum.Tag, elementsFactory);
  }

  openTagsMenu(ids: string[], entityType: EntityTypeEnum): void {
    this.entitiesSetup.next({
      entitiesIds: ids,
      type: entityType,
    });
  }
}
